import { Outlet } from "react-router";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { ToastContainer } from "react-toastify";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./Store/Reducers";
// import SupabaseChannelListener from "./Utils/supabaseChannel";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {/* <SupabaseChannelListener /> */}
        <Outlet />
        <ToastContainer />
      </PersistGate>
    </Provider>
  );
}

export default App;
